export default __webpack_public_path__ + "static/media/fundoLoginBg2-fullhd.c489412b.jpg";